import { EasyModal } from '@app/components/ui';
import { CircleChannelIcon } from '@app/components/ui/icons/icons-list';
import React, { FC } from 'react';

import { ChannelSettingObject, CreateChannelType } from '@app/interfaces/settings.type';

import useTranslation from '@app/hooks/use-translation';

import { CommonSettingsAddForm } from './common-settings-add-form';
type ModalWithForm = {
  isOpenAddChannelModal: boolean;
  changeOpenAddChannelModal: React.Dispatch<React.SetStateAction<boolean>>;
  changeEditMode: React.Dispatch<React.SetStateAction<boolean>>;
  onFormSubmitHandler(data: CreateChannelType): void;
  editMode: boolean;
  channelData: ChannelSettingObject | undefined;
};
export const ModalWithForm: FC<ModalWithForm> = (props) => {
  const { t } = useTranslation('pages.settings');
  const {
    isOpenAddChannelModal,
    changeOpenAddChannelModal,
    onFormSubmitHandler,
    editMode,
    changeEditMode,
    channelData,
  } = props;
  return (
    <EasyModal
      show={isOpenAddChannelModal}
      onRemove={() => changeEditMode(false)}
      label={
        <div className="flex flex-col gap-[13px] items-center justify-center">
          <div className="w-[57px] h-[57px] rounded-full bg-blue_pal flex items-center justify-center">
            <CircleChannelIcon className="text-action" size={25} />
          </div>
          <span className="text-0color text-[24px] font-[700] leading-[29px]">
            {editMode
              ? t('common_setting.modal_title.edit')
              : t('common_setting.modal_title.create')}
          </span>
        </div>
      }
      onClose={() => {
        editMode && changeEditMode(false);
        changeOpenAddChannelModal(false);
      }}
      variant="mediumW650"
      withoutContentPadding
      withoutFooter
    >
      <div className="px-[50px] pb-[48px] pt-[35px]">
        <CommonSettingsAddForm
          channelData={channelData}
          editMode={editMode}
          onFormSubmit={onFormSubmitHandler}
        />
      </div>
    </EasyModal>
  );
};
